/* eslint-disable */
import $ from 'jquery';
import stickybits from 'stickybits';
import BaseModule from './BaseModule';

export default class SectionNav extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'SectionNav');

    if ($(el).hasClass('section-vehicle-nav')) {
      stickybits('.section-vehicle-nav');
    }

    const elm = $(el);
    const containerNav = elm.find('.nav');
    const btnNav = elm.find('.btn-nav-wrapper');

    this.initBtnNav(btnNav, elm, this.slideAnimate);
    this.addResizeListener(containerNav, btnNav);
  }

  initBtnNav(btnNav, containerNav) {
    const width = containerNav.width();
    const distance = width - 50;
    let pos = 0;

    btnNav.on('click', '.btn-nav-next', function (e) {
      e.preventDefault();

      pos = btnNav.siblings('.nav').scrollLeft();
      pos += distance;
      if (pos > btnNav.siblings('.nav')[0].scrollWidth - btnNav.siblings('.nav').width() - 40) {
        pos = btnNav.siblings('.nav')[0].scrollWidth - btnNav.siblings('.nav').width() - 40;
      }
      btnNav.siblings('.nav').scrollLeft(pos);
    });

    btnNav.on('click', '.btn-nav-back', function (e) {
      e.preventDefault();

      pos = btnNav.siblings('.nav').scrollLeft();
      pos -= distance;
      if (pos < 0) {
        pos = 0;
      }
      btnNav.siblings('.nav').scrollLeft(pos);
    });
  }

  addResizeListener(containerNav, btnNav) {
    $(window).on('resize', function () {
      if (window.innerWidth - containerNav[0].clientWidth > 30) {
        btnNav.addClass('hidden');
      }
      else {
        btnNav.removeClass('hidden');
      }
    });

    $(window).trigger('resize');
  }
}
